import apiChange from '../apiChange';

import { ParamsBodyPostQuoteListservices, ParamsDataPostQuoteListservices } from 'utils/typeServices';

type response = {
    errorCode: null;
    message: string;
    success: boolean;
    data: ParamsDataPostQuoteListservices;
}

export const PostQuoteListservices = async ({ body }: { body: ParamsBodyPostQuoteListservices }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiChange.post<response>('/changeservice/quoteListservices/v1', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        if (data.data) {
            return data.data;
        } else {
            return data.message;
        }
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
